import { IABSToken, IStorageExternal } from "./storage-external";
import { IShardRepositoryRaw } from "../../api/entities/shard-repository";

export class StorageABS implements IStorageExternal {
    getToken(storageNode: IShardRepositoryRaw): IABSToken {
        return {
            sasUri: storageNode.sasUri,
            bucket: storageNode.container
        };
    }
}
